export function asyncJs(url, onload=()=>{}) {
  var el = document.createElement('script');
  el.setAttribute("src",url);
  el.setAttribute("type","text/javascript");
  el.onload = onload;
  var head = document.getElementsByTagName('head')[0];
  return head.appendChild(el);
}
